import PostboxDelivery from './postboxDelivery';

export default PostboxDelivery;
